import { render, staticRenderFns } from "./buyerPromotionDetail.vue?vue&type=template&id=880062c6&"
import script from "./buyerPromotionDetail.vue?vue&type=script&lang=js&"
export * from "./buyerPromotionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports